exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vux-modal-open{overflow:hidden;position:fixed;width:100%}.vux-modal-open-for-container{overflow:hidden!important}", "", {"version":3,"sources":["D:/SVN/陕西财控/code/weixin_zl/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA,gBACE,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,8BACE,yBAA2B,CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vux/src/styles/vux-modal.css
// module id = 671
// module chunks = 90